exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#choose-application-time-range-modal label {\n  font-size: 14px;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/gcp-applications/monash-online-credit/monash-online-credit-prod@2/src/main/client/app/staff/dashboard/choose-application-time-range-modal.less","/var/lib/jenkins/workspace/gcp-applications/monash-online-credit/monash-online-credit-prod@2/choose-application-time-range-modal.less"],"names":[],"mappings":"AAAA;EAGI,gBAAA;CCDH","file":"choose-application-time-range-modal.less","sourcesContent":["#choose-application-time-range-modal {\n  label {\n\n    font-size: 14px;\n  }\n}\n\n","#choose-application-time-range-modal label {\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"importLoaders":1}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./src/main/client/app/staff/dashboard/choose-application-time-range-modal.less
// module id = 498
// module chunks = 0